import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Program } from '../../types/content';
import { site } from '../../data/site';
import { programPaths } from '../../data/navigation';
import { usePrograms } from '../../contexts/ProgramContext';
import { ButtonLink } from '../ui/ButtonLink';
interface ProgramCardProps {
  program: Program;
}
export function ProgramCard({
  program
}: ProgramCardProps) {
  const {
    setTrialChoice
  } = usePrograms();
  const isCompetition = program.id === 'competition-team';
  return <article id={`program-${program.id}`} aria-labelledby={`program-${program.id}-title`} className="flex h-full w-full scroll-mt-28 flex-col overflow-hidden rounded bg-white text-left ring-1 ring-line" data-id="element-231" data-mp="18rfm2i4fe8e1">
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-ink" data-id="element-232" data-mp="1hsvx8s32eejb">
        <img src={program.image} alt={program.imageAlt} className="h-full w-full" style={{
        objectPosition: program.imagePosition,
        objectFit: program.imageFit ?? 'cover'
      }} loading="lazy" data-id="element-233" data-mp="2y2y7szoqoge8" />
        <span className="absolute left-3 top-3 rounded-sm bg-ink px-2.5 py-1 text-[13px] font-semibold text-white" data-id="element-234" data-mp="303nit7um8upq">
          {program.audience}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6 lg:p-8" data-id="element-235" data-mp="351758v1gwdsr">
        <h3 id={`program-${program.id}-title`} className="font-display text-[2rem] font-bold uppercase leading-none lg:text-[2.25rem]" data-id="element-236" data-mp="3a11t0ppy4n9l">
          {program.name}
        </h3>
        <p className="text-pretty mt-4 text-base leading-relaxed text-muted" data-id="element-237" data-mp="2he7d8642qc2g">{program.description}</p>

        <h4 className="mt-6 text-sm font-semibold uppercase tracking-[0.1em]" data-id="element-238" data-mp="2mbqtfbkc0yx1">In class, students practice</h4>
        <ul className="mt-3 space-y-2.5" data-id="element-239" data-mp="2r4tm7hhac4c6">
          {program.practices.map(practice => <li key={practice} className="flex items-start gap-3 text-[15px] leading-relaxed" data-id="element-240" data-mp="1tnbppl6ni310">
              <span className="mt-[10px] h-[3px] w-4 shrink-0 bg-brand" aria-hidden="true" data-id="element-241" data-mp="1ylmxlqddy3gl" />
              <span data-id="element-242" data-mp="1qkxhbrw6tvpz">{practice}</span>
            </li>)}
        </ul>

        <div className="mt-6 border-t border-line pt-5" data-id="element-243" data-mp="1mlgbuygrgykt">
          <h4 className="text-sm font-semibold" data-id="element-244" data-mp="1miu3wxpykh22">A good fit for</h4>
          <p className="text-pretty mt-2 text-[15px] leading-relaxed text-muted" data-id="element-245" data-mp="20aqjy3ecr0i3">{program.goodFit}</p>
        </div>

        <div className="mt-auto pt-6" data-id="element-246" data-mp="1vdqk4a83itzf">
          <a href={programPaths[program.id]} className="mb-4 inline-flex min-h-[44px] items-center gap-2 font-semibold underline decoration-brand decoration-2 underline-offset-4 hover:text-brand" data-id="element-247" data-mp="17n4c2iy3d9pf">Explore {program.name}<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="1hm3e3iocq73g" /></a>
          <div data-id="element-249" data-mp="1hj7hbxo8pogl">
          <ButtonLink href={isCompetition ? `${site.emailHref}?subject=${encodeURIComponent('Competition Team inquiry')}` : '#first-class'} onClick={() => {
            if (!isCompetition) setTrialChoice(program.id);
          }} className="w-full !whitespace-normal py-3 text-center leading-snug md:w-fit" icon={<ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-251" data-mp="9sblk6xzfhrc" />} data-id="element-250" data-mp="1cmqrmz1e721e">
            {program.ctaLabel}
          </ButtonLink>
          </div>
        </div>
      </div>
    </article>;
}